<template>
    <v-layout column align-center class="visual text-center white--text">
        <v-img src="/images/logo.png" max-width="100%" contain class="mb-6 mb-md-8 w-180px w-md-260px" />
        <div class="visual__title mb-4 mb-md-6 px-10px px-md-0 mw-100" data-aos="fade-up" :data-aos-delay="$vuetify.breakpoint.mdAndUp ? 200 : 0">
            <v-img src="/images/event/hunt/title.png" max-width="100%" width="750" :aspect-ratio="750 / 380" contain alt="대한문고가 쏜다 여름맞이 보물찾기 EVENT!"/>
            <v-img src="/images/event/hunt/icon-watergun.svg" :aspect-ratio="176 / 132" class="icon-watergun"/>
        </div>
        <!-- <v-img src="/images/event/hunt/title.png" max-width="100%" width="1112" :aspect-ratio="1112 / 380" contain alt="대한문고가 쏜다 여름맞이 보물찾기 EVENT!" class="mb-6 mb-md-8"/> -->
        <h3 class="tit tit--sm text-shadow" data-aos="fade-up">이벤트 진행 기간</h3>
        <h4 class="tit font-weight-black text-shadow" data-aos="fade-up" :data-aos-delay="$vuetify.breakpoint.mdAndUp ? 50 : 0">2023.07.17 ~ 2023.07.30</h4>
        <v-layout column align-center class="mt-50px mt-md-80px mt-lg-110px">
            <h4 class="tit text-shadow mb-4 mb-md-6" data-aos="fade-up">참여방법</h4>
            <v-row justify="center" class="ma-n2 ma-md-n8">
                <v-col cols="12" sm="auto" class="pa-2 pa-md-8" data-aos="fade-up" :data-aos-delay="$vuetify.breakpoint.mdAndUp ? 50 : 0">
                    <h5 class="txt txt--xl text-shadow">대한문고 <br>로그인</h5>
                </v-col>
                <v-col cols="auto" class="pa-2 pa-md-8" data-aos="fade-up" :data-aos-delay="$vuetify.breakpoint.mdAndUp ? 100 : 0">
                    <i class="icon icon-right-arrow mt-sm-2 mt-md-3" />
                </v-col>
                <v-col cols="12" sm="auto" class="pa-2 pa-md-8" data-aos="fade-up" :data-aos-delay="$vuetify.breakpoint.mdAndUp ? 100 : 0">
                    <h5 class="txt txt--xl text-shadow">이벤트 페이지에서 <br>보물상자 고르기</h5>
                </v-col>
                <v-col cols="auto" class="pa-2 pa-md-8" data-aos="fade-up" :data-aos-delay="$vuetify.breakpoint.mdAndUp ? 150 : 0">
                    <i class="icon icon-right-arrow mt-sm-2 mt-md-3" />
                </v-col>
                <v-col cols="12" sm="auto" class="pa-2 pa-md-8" data-aos="fade-up" :data-aos-delay="$vuetify.breakpoint.mdAndUp ? 200 : 0">
                    <h5 class="txt txt--xl text-shadow text-sm-left mb-1">당첨 상품확인</h5>
                    <p class="txt txt--sm font-weight-bold text-shadow text-sm-left" style="color: rgba(255, 255, 255, 0.5)">
                        당첨된 상품은 마이페이지 <br>
                        ‘이벤트 참여내역’에서 확인 가능
                    </p>
                </v-col>
            </v-row>
        </v-layout>
    </v-layout>
</template>

<script>

export default {
    data() {
        return {
        }
    },
}
</script>

<style lang="scss" scoped>
@import "@/styles/_event.scss";
.text-shadow{
    text-shadow: 2px 2px rgba(29, 100, 166, 0.45);
}
.icon-right-arrow{
    width: 26px;
    height: 26px;
    background-image: url(/images/event/hunt/icon-bottom-arrow.svg);
}
.visual{
    &__title{
        position: relative;
    }
    .icon-watergun{
        max-width: 25%;
        position: absolute;
        bottom: 8%;
        left: 20px;
        transform: translateX(-100%);
    }
}
@media (min-width:576px){
    .icon-right-arrow{  
        background-image: url(/images/event/hunt/icon-right-arrow.svg);
    }
}
@media (min-width:768px){
    .visual{
        .icon-watergun{
            max-width: 172px;
            bottom: 40px;
            left: -10px;
        }
    }
}
@media (min-width:1024px){
}
@media (min-width:1200px){
}

</style>